export default __webpack_public_path__ + "static/media/winery.a4a3a875.svg";